import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchGiveawayData,
  selectGiveawayData,
  selectGiveawayFetchError,
  selectGiveawayLoading,
  BannerSection,
  useMe,
  AppDispatch, LoadingState, ErrorState, PageWrapper, TitleRow
} from '@/shared';

import { Subtitle } from './styled';
import { ClaimGift, GiftClaimed, UnlockGift } from './components';

export const Giveaway: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const meService = useMe();
  const giveawayData = useSelector(selectGiveawayData);
  const loading = useSelector(selectGiveawayLoading);
  const error = useSelector(selectGiveawayFetchError);

  React.useEffect(() => {
    dispatch(fetchGiveawayData());
  }, [dispatch]);

  if (loading) return <LoadingState />;
  if (error) return <ErrorState title="Failed to load giveaway data" />;

  return (
    <>
      <PageWrapper>
        <TitleRow weight={3} color="#FFFFFF" margin="10px 0px 20px 0px">
          Get free fans.cspr subname
        </TitleRow>

        <BannerSection imagePath="https://cspr.fans/media/season5-free-subname.jpg" />

        <Subtitle weight={3} size="md">
          We are giving away a special gift for true Casper fans! Claim a free .fans.cspr
          subname, set it as your primary on-chain identity, and use it across the Casper ecosystem.
        </Subtitle>

        <UnlockGift />
      </PageWrapper>

      {giveawayData?.assigned_subname?.primary || meService?.data?.wallet?.cspr_name ? (
        <GiftClaimed />
      ) : (
        <ClaimGift />
      )}
    </>
  );
};
